// extracted by mini-css-extract-plugin
module.exports = {"main":"BotAndAutomation_main__3SIwv"};